import React from 'react';
import { Badge, Typography, Link } from '@one-thd/sui-atomic-components';
import { useTheme } from '@thd-olt-component-react/theme-provider';
import { TConcreteRouteGroup } from '../models/navigation';
import AccountDashboardLink from './AccountDashboardLink';
import { CustomerAccountNavigationWrapper } from './CustomerAccountNavigationWrapper';
import { dataModel } from './data-model';
import { useMatchMedia } from '../hooks/useMatchMedia';

interface CustomerAccountNavigationProps {
  forceRender?: boolean;
}

interface AccountSidebarLinksProps {
  concreteRouteGroups: TConcreteRouteGroup[];
  activeRoute: string;
  triggerLinkAnalytics: (analyticsName: string) => void;
}

const AccountSidebarLinks: React.FC<AccountSidebarLinksProps> = ({
  concreteRouteGroups,
  activeRoute,
  triggerLinkAnalytics,
}) => {
  return (
    <>
      <AccountDashboardLink />
      {concreteRouteGroups.map((routeGroup) => (
        <div className="sm:sui-mb-8" key={routeGroup.title}>
          {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
          <div className="sui-py-3 sm:sui-py-0 sm:sui-mb-2 lg:sui-w-min lg:sui-min-w-[75%]">
            <Typography variant="h4" height="tight">
              {routeGroup.title}
            </Typography>
          </div>
          <div className="sui-flex sui-flex-col">
            {routeGroup.links.map(({ label, path, analyticsName }) => {
              const isActive = path === activeRoute;
              return (
                <div
                  key={`${label}-${path}`}
                  className={`sui-pl-2 sui-py-1 ${
                    isActive ? 'sui-bg-subtle' : ''
                  }`}
                >
                  <Link
                    href={path}
                    underline="hover"
                    hight="tight"
                    onClick={() => triggerLinkAnalytics(analyticsName)}
                  >
                    {label}
                  </Link>
                  {label === 'Projects' && (
                    <span className="sui-px-2">
                      <Badge
                        data-testid="beta-badge"
                        variant="regular"
                        color="info"
                        size="small"
                      >
                        Beta
                      </Badge>
                    </span>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </>
  );
};

const CustomerAccountNavigation = ({
  forceRender = false,
}: CustomerAccountNavigationProps) => {
  const { matches } = useMatchMedia();
  const skipQuery = !forceRender && !matches;
  const theme = useTheme(CustomerAccountNavigation);
  const { isStoreFront } = theme.props;
  return (
    <CustomerAccountNavigationWrapper
      skipQuery={skipQuery}
      isStoreFront={isStoreFront}
    >
      {({ concreteRouteGroups, activeRoute, triggerLinkAnalytics }) => (
        <div
          className={`${forceRender ? 'sui-block' : 'sui-hidden'} lg:sui-block`}
          data-component="CustomerAccountNavigation"
        >
          <AccountSidebarLinks
            concreteRouteGroups={concreteRouteGroups}
            activeRoute={activeRoute}
            triggerLinkAnalytics={triggerLinkAnalytics}
          />
        </div>
      )}
    </CustomerAccountNavigationWrapper>
  );
};

CustomerAccountNavigation.displayName = 'CustomerAccountNavigation';

CustomerAccountNavigation.defaultProps = {
  forceRender: false,
};

CustomerAccountNavigation.themeProps = {
  isStoreFront: Boolean,
};

CustomerAccountNavigation.defaultThemeProps = {
  isStoreFront: false,
};

CustomerAccountNavigation.dataModel = dataModel;

export { CustomerAccountNavigation };
